import React from 'react'
import App from '../../../components/app/App'
import TwoFactorAuthContainer from './TwoFactorAuthContainer'

export default () => (
    <App>
        <TwoFactorAuthContainer />
    </App>
)
